import { useApp } from "@/context/AppContext";
import { IMAGES } from "@/data/site";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { Section } from "@/components/Section";
import ProjectsMap from "@/components/ProjectsMap";
import { Sun, Mountain, Clapperboard, MapPin } from "lucide-react";

export default function Operations() {
  const { t } = useApp();
  const m = t.mapP;
  const legend = [
    { v: "solar", icon: Sun, color: "text-amber-500" },
    { v: "mining", icon: Mountain, color: "text-teal-600" },
    { v: "media", icon: Clapperboard, color: "text-purple-600" },
  ];
  return (
    <div>
      <PageHero image={IMAGES.building} eyebrow={m.eyebrow} title={m.title} subtitle={m.sub} />
      <Section sid="operations.map" name="Operations Map" className="oj-section">
        <div className="oj-container">
          <Reveal>
            <div className="flex flex-wrap items-center gap-4 mb-6">
              <div className="oj-eyebrow"><MapPin className="w-4 h-4" /> {m.legend}</div>
              {legend.map(({ v, icon: Icon, color }) => (
                <span key={v} className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600">
                  <Icon className={`w-4 h-4 ${color}`} /> {m.verticals[v]}
                </span>
              ))}
            </div>
          </Reveal>
          <Reveal delay={0.1}>
            <ProjectsMap height="560px" />
          </Reveal>
          <p className="mt-5 text-sm text-slate-500 text-center">{m.note}</p>
        </div>
      </Section>
    </div>
  );
}
